module.exports = {
	"orders": {
		"attributes": {
			"transaction": "Transacação",
			"price": "Valor",
			"payment_method_type": "Tipo",
			"status": "Status",
			"created_at": "Data",
			"customer": "Cliente",
			"contract": "Assinatura",
			"contract_code": "Código Contrato",
			"external_code": "Código externo"
		},
		"main": {
			"breadcrumb_title": "Listagem de transação",
			"breadcrumb_path": "Transações"
		},
		"status": {
			"pending": "Pendente",
			"not_paid": "Não Pago",
			"paid": "Pago",
			"reversed": "Estornado",
			"awaiting_approval": "Aguardando aprovação",
			"reproved_analysis": "Reprovada na análise"
		},
		"type": {
			"card": "Cartão",
			"billet": "Boleto",
			"balance": "Saldo",
			"transfer": "Trasferencia"
		},
		"filter": {
			"contract_code": "Código do contrato",
			"invoice_id": "ID Fatura"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/orders/pt-BR.yml
// module id = 586
// module chunks = 1